// TODO: Убрать отладочные логи — весь файл

/**
 * Simple debug logger for the reference-data loading pipeline.
 * Accumulates timestamped messages; UI reads them via useDebugLog().
 */

export interface DebugLogEntry {
  ts: string;
  msg: string;
}

const entries: DebugLogEntry[] = [];
let listener: (() => void) | null = null;

function now(): string {
  return new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function dbg(msg: string): void {
  entries.push({ ts: now(), msg });
  listener?.();
}

export function getDebugLog(): DebugLogEntry[] {
  return entries;
}

export function clearDebugLog(): void {
  entries.length = 0;
  listener?.();
}

export function subscribeDebugLog(cb: () => void): () => void {
  listener = cb;
  return () => { listener = null; };
}
